const commonModule = {
  confirm: "확정",
  cancel: "취소",
  home: "메인 화면",
  search: "검색",
  order: "주문서 한눈에",
  coupon: "쿠폰 보기",
  user: "나의",
  save: "저장",
  isDelete: "삭제합니까?",
  isCancel: "취소합니까?",
  addSuccess: "새로 추가 성공",
  cancelSuccess: "취소 성공",
  add: "추가",
  delete: "삭제",
  submit: "제출",
  emailFormat: "메일 격식 오류",
  example: "예",
  min: "분",
  noContent: "많은 증거를 잠시 열거하다.", //机
  privateBrowse:"현재 패턴이 없습니다. 패턴이 없는 모드를 복원하여 정상적인 기능을 제공합니다", //机
  back: "뒤로가기",
  detail: "자세 한 정보",
  store: "점포",
  amount: "금액",
  loading: "불러오는 중...",
  bn: "번호",
  goHome: "홈 페이지로 돌아가기",
  desc1:"발매중인 표",
  agree:"개인정보 보호 정책에 먼저 동의하십시오",
  card:"신용 카드 선택",
  point_list:"볼거리 목록",
  invoice:"내용을 기재하십시오",
  jpPhone:"일본 +81",
  cnPhone:"중국 +86",
  krPhone:"한국 +82",
  hkPhone:"홍콩 +852",
  moPhone:"마카오 +853",
  twPhone:"대만 +886",
  useNum:"사용량",
  useSuccess:"이용하는데 성공하다",
  isUse:"이용하시겠습니까?",
  couponOrder:"주문서 번호",
  couponCount1:"사용 가능 쿠폰 수량",
  couponCount2:"사용 쿠폰 갯수",
  couponCount3:"만기채권수",
  couponCount4:"쿠폰 획득 숫자",
  couponTime:"시간을 얻다",
  couponShop:"가게 이름",
  couponAddr:"주소",
  couponStatus1:"사용하지 않음",
  couponStatus2:"부분 사용",
  couponStatus3:"사용을 마치다",
  couponStatus4:"기한이 지났음",
  close:"닫기",
  comment: "논평",
  copy: "복사",
  copySuccess: "복사 성공",
  copyFailed: "복사 실패",
};

export default commonModule;
